<template>
  <div style="padding-top: 30px;">
    <header id="page-topbar">
      <div
        class="navbar-header headerPage d-flex justify-content-between"
        style="height: 80px; padding: 24px"
      >
        <BaseButton variant="secondary" @click="$router.push(`/setting`)">
          Quay lại
        </BaseButton>
        <div class="headerPage-title">
          <p>Cấu hình bán hàng</p>
        </div>

        <BaseButton type="submit" @click="submitConfig()">
          Hoàn tất
        </BaseButton>
      </div>
    </header>

    <div v-if="dataPermission && dataPermission.includes('NSH_MCMNT_MERCHANT_UPDATE')">
      <b-form>
        <LayoutCard>
          <LayoutCardTitle>Thông tin quản lý kho </LayoutCardTitle>
          <div class="b-checkbox">
            <b-form-checkbox v-if="serialImeiCheck" v-model="serialMgmt" checked="checked" disabled="disabled">Quản lý sản phẩm theo serial/imei</b-form-checkbox>
            <b-form-checkbox v-else v-model="serialMgmt">Quản lý sản phẩm theo serial/imei</b-form-checkbox>
          </div>
          <div>
            <b-form-checkbox v-if="expiryMgmtCheck" v-model="expiryMgmt" checked="checked" disabled="disabled"> Bán hàng theo lô/HSD</b-form-checkbox>
            <b-form-checkbox v-else v-model="expiryMgmt"> Bán hàng theo lô/HSD</b-form-checkbox>
          </div>
        </LayoutCard>

        <LayoutCard>
          <LayoutCardTitle>Cấu hình bán hàng</LayoutCardTitle>

          <div>
            <BaseCheckbox 
              class="d-inline-block"
              v-model="inventoryMinus"
            />
            Cho phép tạo đơn đặt hàng âm
          </div>
          <div>
            <b-form-checkbox v-model="expiredSale"> Cho phép bán lô hàng đã hết hạn sử dụng.</b-form-checkbox>
          </div>
          <div>
            <BaseCheckbox 
              class="d-inline-block"
              v-model="pushPaymentMgmt"
              @click="checkMposConnect()"
            />
            Bán hàng quẹt thẻ trên web
            <br/>
            <router-link 
              style="padding: 33px"
              to="/setting/mpos-connect"
            >
              Xem thông tin liên kết tài khoản MPOS</router-link>
          </div>

        </LayoutCard>

        <LayoutCard>
          <LayoutCardTitle>Đổi trả hàng</LayoutCardTitle>
          <div>
            <b-form-checkbox v-model="refundPolicy"> Không hoàn tiền khi đổi trả hàng</b-form-checkbox>
          </div>
          <div>
            <BaseCheckbox 
              class="d-inline-block"
              v-model="enableLimitReturnTime"
            />
            Giới hạn thời gian cho phép trả hàng ({{returnTimeLimit}} {{getItemInArrReturnTimeUnit(returnTimeUnit)}})
            <br/>
            <a href="javascript:void(0)" style="padding: 33px;" class="text-primary" v-if="enableLimitReturnTime" @click="popupEnableLimitReturnTime=true">Cài đặt thời gian cho phép trả hàng</a>
          </div>

          <!--Popup set thoi gian tra hang--> 
          <el-dialog append-to-body title="Thời gian cho phép trả hàng" :visible.sync="popupEnableLimitReturnTime" class="boxInfoOneItemPos">
            <div class="content-item-pos-change">
              <div>Thời gian</div>
              <div class="row">
                <div class="col-md-6">
                  <input type="text"
                    id="numDateRefurn"
                    @keydown.enter.prevent
                    @keydown="allowNumbersOnly"
                    class="input input-sm w-100"
                    v-model="returnTimeLimit"
                  />
                </div>
                <div class="col-md-6">
                    <el-select v-model="returnTimeUnit" placeholder="Chọn kiểu" id="arrDateRefurn" class="w-100">
                      <el-option v-for="(item, index) in arrReturnTimeUnit" :key="index" :label="item.text" :value="item.id"></el-option>
                    </el-select>
                </div>
              </div>
            </div>
            <hr class="hr-solid mt-3" />
            <div class="bottom-item-action-chagne mt-3 w-100 text-right">
              <button class="btn btn-primary" @click="popupEnableLimitReturnTime=false">Áp dụng</button>
            </div>
          </el-dialog>
        </LayoutCard>

      </b-form>
    </div>
    <NotPermission v-else></NotPermission>


    <!-- ================= POPUP KICH HOAT KHO HANG =================== -->
    <!-- ============================================================== -->
    <!--
    <LayoutPopup id="kich-hoat-qlsp-serial-imei">
      <template #title>Cấu hình quản lý sản phẩm theo serial/imei thành công!</template>
      <template #content>
        <div class="icon-success text-center mb-4">
          <IconInventory />
        </div>
        <div class="content-success text-center">
          Từ giờ bạn đã có thể quản lý sản phẩm theo serial/imei!
        </div>
      </template>
      <template #control-right>
        <BaseButton 
          size="sm" 
          variant="secondary" 
          @click="hidePopup('')"
        >
          Quay lại
        </BaseButton>
        <BaseButton size="sm" @click="this.hidePopup('kich-hoat-qlsp-serial-imei')">
          Xác nhận
        </BaseButton>
      </template>
    </LayoutPopup>
    -->

    <!-- ================= POPUP KICH HOAT KHO HANG =================== -->
    <!-- ============================================================== -->
    <!--
    <LayoutPopup id="kich-hoat-kho-hang-thanh-cong" size="small">
      <template #title>Kích hoạt kho hàng thành công!</template>
      <template #content>
        <div class="icon-success text-center mb-4">
          <IconInventory />
        </div>
        <div class="content-success text-center">
          Từ giờ bạn đã có thể thêm sản phẩm bằng cách Nhập kho, Kiểm hàng trong kho, và nhiều tính năng khác!
        </div>
      </template>
      <template #control-right>
        <BaseButton 
          size="sm" 
          variant="secondary" 
          @click="hidePopup('kich-hoat-kho-hang-thanh-cong')"
        >
          Quay lại
        </BaseButton>
        <BaseButton 
          size="sm">
          Nhập kho ngay
        </BaseButton>
      </template>
    </LayoutPopup>
    -->

    <!-- ===================== CHECK LIEN KET MPOS ==================== -->
    <!-- ============================================================== -->

    <LayoutPopup id="check-lien-ket-mpos" size="small">
      <template #title>Liên kết MPOS</template>
      <template #content>
        <div class="icon-success text-center mb-4">
          <IconMposCheck />
        </div>
        <div class="content-success text-center">
          Bạn chưa liên kết với MPOS. Vui lòng liên kết tài khoản MPOS để sử dụng tính năng này.
        </div>
      </template>
      <template #control-right>
        <BaseButton 
          size="sm" 
          variant="secondary" 
          @click="hidePopup('check-lien-ket-mpos')"
        >
          Quay lại
        </BaseButton>
        <BaseButton size="sm" @click="clickMapMpos">
          Liên kết
        </BaseButton>
      </template>
    </LayoutPopup>
    <div class="box-loading" v-show="loading">
      <div class="loading">
        <b-spinner variant="primary" label="Loading..." />
      </div>
    </div>

  </div>
</template>

<script>
import Swal from "sweetalert2";
import NotPermission from '@/components/not-permission'
import IconMposCheck from "@/components/icons/icon_mpos_check.vue"
//import IconInventory from "@/components/icons/icon_inventory.vue"
import { SettingService } from "@/services/nextshop/setting.service";
import getListLocation from "@/mixins/location/getListLocation";

export default {
  components: {
    
    NotPermission,
    IconMposCheck,
    //IconInventory,
  },
  mixins: [
    getListLocation,
  ],
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentUser")),
      loading: false,
      title: "CÀI ĐẶT KHO",
      items: [
        {
          text: "Quản lí kho",
          "/setting": "#",
        },
        {
          text: "Kho",
          active: true,
        },
      ],
      dataMapMposParamsUrl:{
        token: process.env.VUE_APP_LINK_TOKEN_MPOS,
        callbackUri: process.env.VUE_APP_URL + '/setting/mpos-connect',
        callbackUriRemove: process.env.VUE_APP_URL + '/setting/mpos-remove-connect',
        isLink: 'yes',
        appName:'NEXT360'
      },
      inventoryMinus: false,
      serialMgmt: false,
      expiryMgmt: false,
      pushPaymentMgmt: false,
      dataRes: {},
      serialImeiCheck: false,
      expiryMgmtCheck: false,
      resDataMC: [],
      expiredSale: false,

      refundPolicy: false, //NO_REFUND, REFUND
      enableLimitReturnTime: false,
      returnTimeLimit: 0,
      returnTimeUnit: 'DAYS', //DAYS, WEEKS, MONTHS, YEARS
      arrReturnTimeUnit: [
        {id: 'DAYS', text: 'Ngày'},
        {id: 'WEEKS', text: 'Tuần'},
        {id: 'MONTHS', text: 'Tháng'},
        {id: 'YEARS', text: 'Năm'}
      ],
      popupEnableLimitReturnTime: false,
      mposAccount: null
    }
  },
  async created() {
    this.loading = true;
    await this.getDataMerchant();
    await this.getMcInfo();
    await this.getMainApiMerchantReturn();
    this.loading = false;
  },
  methods: {
    checkMposConnect() {
      if(this.mposAccount == null || this.mposAccount == ''){
          this.showPopup('check-lien-ket-mpos')
      }
    },

    clickMapMpos(){
      const link = process.env.VUE_APP_MAP_MPOS_URL + '?token='+this.dataMapMposParamsUrl.token+'&callbackUri='+this.dataMapMposParamsUrl.callbackUri+'&appName='+this.dataMapMposParamsUrl.appName+'&isLink='+this.dataMapMposParamsUrl.isLink
      window.location.href = link
    },

    async submitConfig() {
      this.loading = true;
      const resItemMGMT = await SettingService.updateItemConfig({
        serialImei: this.serialMgmt,
        expiry: this.expiryMgmt
      });

      const resNegativeINV = await SettingService.updateNagativeInventory({
        activeNegativeInv: this.inventoryMinus,
         expiredSale: this.expiredSale
      });

      const resPaymentMPOS = await SettingService.updatePushPayment({
        merchantId: this.inforMerchant.merchantId,
        pushPayment: this.pushPaymentMgmt
      });
      
      await this.updateMainApiMerchantReturn()

      this.loading = false;
      
      if (resItemMGMT.success 
        && (resPaymentMPOS.success || !resPaymentMPOS.success && resPaymentMPOS.code == "MPOS_ACCOUNT_NOT_LINKED_YET") 
        && resNegativeINV.success
      ) {
        Swal.fire({
          icon: "success",
          title: "Thành công",
          text: "Cấu hình bán hàng thành công.",
          confirmButtonText: "Xác nhận",
        })
        .then(()=> {
          this.$router.push({ path: `/setting` })
          this.hidePopup('kich-hoat-qlsp-serial-imei')
        });
      } else if (!resItemMGMT.success) {
        Swal.fire({
          icon: "warning",
          title: "Thất bại",
          text: 'Cấu hình sản phẩm serial/imei lỗi, vui lòng thử lại',
          confirmButtonText: "Xác nhận",
        })
      } else if (!resPaymentMPOS.success && resPaymentMPOS.code != "MPOS_ACCOUNT_NOT_LINKED_YET") {
        Swal.fire({
          icon: "warning",
          title: "Thất bại",
          text: 'Cấu hình bán hàng quẹt thẻ lỗi, vui lòng thử lại',
          confirmButtonText: "Xác nhận",
        })
      } else if (!resNegativeINV.success) {
        Swal.fire({
          icon: "warning",
          title: "Thất bại",
          text: 'Cấu hình tạo đơn hàng bán âm lỗi, vui lòng thử lại',
          confirmButtonText: "Xác nhận",
        })
      }
    },

    async getDataMerchant() {
      try {
        const responseDataMC = await SettingService.getDataMerchant();
        this.dataRes = responseDataMC.data
        if (responseDataMC.success) {
          this.inventoryMinus = responseDataMC.data.merchant.activeNegativeInv
          this.serialMgmt = responseDataMC.data.merchant.itemMgmtMethod.serialImei
          this.serialImeiCheck = responseDataMC.data.merchant.itemMgmtMethod.serialImei
          this.expiryMgmt = responseDataMC.data.merchant.itemMgmtMethod.expiry
          this.expiryMgmtCheck = responseDataMC.data.merchant.itemMgmtMethod.expiry
          this.pushPaymentMgmt = responseDataMC.data.merchant.payMethod.pushPayment && responseDataMC.data.merchant.payMethod.mpos ? true : false
          this.expiredSale = responseDataMC.data.merchant.expiredSale
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getMcInfo() {
      try {
        const response = await SettingService.getMcInfo({
          coMerchantId: this.dataRes.merchant.coMerchantId
        });
        if (response.success) {
          this.mposAccount = response.data.merchant.mposAccount
        }
      } catch (error) {
        console.log(error);
      } 
    },
    async getMainApiMerchantReturn(){
      try {
        const response= await SettingService.mainApiMerchant();
        if(response.success){
          this.refundPolicy = (response.data.refundPolicy === 'REFUND') ? false : true
          this.enableLimitReturnTime = response.data.enableLimitReturnTime
          this.returnTimeLimit =  response.data.returnTimeLimit
          this.returnTimeUnit =  response.data.returnTimeUnit
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateMainApiMerchantReturn(){
        const params = {
          refundPolicy: (this.refundPolicy == true) ? 'NO_REFUND' : 'REFUND',
          enableLimitReturnTime: this.enableLimitReturnTime,
          returnTimeLimit: this.returnTimeLimit,
          returnTimeUnit: this.returnTimeUnit
        }
       await SettingService.mainApiMerchantPut(params)
    },
    getItemInArrReturnTimeUnit(item){
        const index = this.arrReturnTimeUnit.findIndex((e) => e.id == item)
        if(index != -1){
          return this.arrReturnTimeUnit[index].text
        }
    }
  },
}
</script>

<style lang="scss" scoped>

.navbar-header {
  .headerPage {
    &-button-return {
      padding: 8px 14px;
      align-items: center;
      width: 87px;
      background: #ecf0fe;
      border: 1px solid #ecf0fe;
      box-sizing: border-box;
      border-radius: 6px;
      color: #3e69f6;
      font-weight: normal;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        background: #e2e8fc;
      }
    }

    &-title {
      p {
        font-weight: 600;
        font-size: 24px;
        line-height: 125%;
        margin: 0px;
        color: #23313e;
        cursor: context-menu;
      }
    }

    &-button-submit {
      padding: 8px 14px;
      width: 91px;
      background: #3e69f6;
      border: 1px solid #3e69f6;
      box-sizing: border-box;
      border-radius: 6px;
      color: #ffffff;
      font-weight: normal;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        background: #365ee4;
      }
    }
  }
}
.b-checkbox .custom-checkbox .custom-control-label::before {
  border-radius: 1px;
}
</style>